import React, { MouseEvent } from 'react';

import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { notificationsActions, useStore } from '@modules';
import { NotificationTypesEnum } from '@modules/notifications/types';

import CopyIcon from './copy.svg';

import style from './CopyText.scss';

const cn = bemCssModules(style, 'CopyText');

export type TCopyText = {
  text: string;
  title?: string;
  onCopy?: () => void;
  hideIcon?: boolean;
  iconClassName?: string;
};

const CopyText: CustomFC<TCopyText> = props => {
  const { className, text, children, title, onCopy, hideIcon, iconClassName } = props;

  const { t } = useTranslation();
  const [, dispatch] = useStore();

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    copy(text);
    onCopy?.();
    const data = { message: t('operations.copied'), type: NotificationTypesEnum.toast };
    dispatch(notificationsActions.add(data));
  };

  return (
    <button
      className={cn(null, ['link', className])}
      type="button"
      onClick={onClick}
      title={title || t('operations.copy')}
    >
      <div className={cn('wrapper')}>
        {!hideIcon && <CopyIcon className={cn('icon', [iconClassName])} />}
        <span className={cn('text')}>{children || text}</span>
      </div>
    </button>
  );
};

export default CopyText;
